import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'loading' })
export class LoadingPipe implements PipeTransform {
	transform(value) {
		if (value === null || value === undefined) {
			return "...";
		}

		return value;
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/loading.pipe.ts